import config from 'config';
import { action, autorun, computed, observable } from 'mobx';
// Import stores
import MediahubStore from 'stores/MediahubStore';
import ViewStore from 'stores/ViewStore';
// Import API
import API from 'utils/api';

import { getDirectLink, getMetaForMC, getPreviewImage } from 'utils/helpers';

/**
 * MediaContainer Class
 */
export default class MediaContainer {
  @observable content = {};
  @observable thumbs  = [];

  constructor(mediaContainer) {
    this.content = mediaContainer;

    // Load high resultion images for currentContainer type image
    autorun(() => {
      if(_.isEqual(MediahubStore.currentContainer, this)
         && _.isEqual(this.type, 'image')
         && !this.previewImage
      ) {
        // Deliver download links
        this.deliverDownloadLink();
      }
    });
  }

  @computed
  get id() {
    return this.content.mediaContainerId;
  }

  @computed
  get channelId() {
    return this.content.channelId;
  }

  @computed
  get title() {
    return getMetaForMC(this.content, 'container_name', ViewStore.language);
  }

  @computed
  get description() {
    return getMetaForMC(this.content, 'container_description', ViewStore.language);
  }

  @computed
  get fileName() {
    const { fileName, fileExtension } = this.content;
    const name                        = _.truncate(fileName, {
      'length':    20,
      'separator': ' ',
    });
    return `${name}.${fileExtension}`;
  }

  @computed
  get meta_copyright() {
    return getMetaForMC(this.content, 'meta_copyright', ViewStore.language);
  }

  @computed
  get thumbnail() {
    // return _.result(_.head(this.thumbs), 'signedUrl', '');
    return getPreviewImage(this.thumbs, 240);
  }

  @computed
  get previewImage() {
    return getPreviewImage(this.thumbs, 1280);
  }

  @computed
  get directLink() {
    // If directLinks returns empty array then use the channel id instead
    const directLink = getDirectLink(this.content.directLinks, ViewStore.language)
                       || `${this.channelId}/${this.id}`;
    return directLink;
  }

  @computed
  get sortCriteria() {
    return this.content.sortCriteria;
  }

  @computed
  get tags() {
    return this.content.tags_full;
  }

  @computed
  get type() {
    return this.content.type;
  }

  @computed
  get player() {
    const link = _.result(this.content, 'player', '');

    if(!link) {
      return link;
    }

    let apiLink = API.getEnv() === "DEV"
      ? `https://playerdev.admiralcloud.com/#${link}`
      : `https://playerdev2.admiralcloud.com/#${link}`;

    let hash = apiLink.split('#')[1];

    if(hash) {
      hash = hash.replace('?', '~~~').replace(/\?/g, '&').replace('~~~', '?');

      let baseUrl          = apiLink.split('#')[0];
      let mediaContainerId = hash.split('?')[0];
      let optionalQuery    = hash.split('?')[1];

      apiLink = baseUrl + '?v=' + mediaContainerId;
      if(optionalQuery) {
        apiLink += '&' + optionalQuery;
      }
    }

    return apiLink;
  }

  @computed
  get created() {
    const created = this.content.publishedDate;

    return !!created
      ? moment(created).format('DD.MM.YYYY')
      : ViewStore.get('noCreationDate');
  }

  @computed
  get duration() {
    const duration = moment(this.content.duration || 0).format('m:ss');
    return `${duration} Min`;
  }

  /**
   * Set thumbs action
   */
  @action
  setThumbnails(thumbs) {
    _.forEach(thumbs, (t) => {
      this.thumbs.push(t);
    });
  }


  /**
   * Get images for current mediaContainer
   */
  @action
  deliverDownloadLink() {

    const data = {
      'ids':       [this.id],
      'channelId': this.channelId,
      'download':  true,
    };

    if(data.download) {
      data.previewImages = true;
    }

    _.forEach(['original', 240], (downloadLink) => {
      if(_.isInteger(downloadLink)) {
        data['width'] = downloadLink;
      }

      if(config.includeAuthToken) {
        data['token'] = API.token;
      }

      API.post('deliverThumbs', { data })
        .then((result) => this.setThumbnails(result));
    });

  }
}



// WEBPACK FOOTER //
// ./src/stores/models/MediaContainer.js